
import { Component, Prop, Vue } from 'vue-property-decorator';
import CommentRepositoryInterface from '@/services/QA/comment/interfaces';

@Component({
  inject: [
    'commentRepository',
  ],
})
export default class EditCommentDialog extends Vue {
  @Prop() private readonly commentId!: number;
  @Prop() private readonly content!: string;
  @Prop() private readonly notifyUsers!: boolean;
  private newContent: string = '';
  private commentRepository!: CommentRepositoryInterface;
  private visible: boolean = true;

  get message(): string {
    return 'Content';
  }

  public created(): void {
    this.newContent = this.content;
  }

  private async editComment(): Promise<void> {
    try {
      await this.commentRepository.editComment(this.commentId, this.newContent, this.notifyUsers);

      this.$successDialog.show('Comment Edited');
      this.$emit('commentEdited', this.commentId, this.newContent);
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message);
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
